export default __webpack_public_path__ + "static/media/not-found.fd243092.svg";